import { jwtDecode } from 'jwt-decode';     // ← fixed: named export
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

let logoutTimer = null;

/**
 * Parse the JWT stored in localStorage and return its exp timestamp (seconds).
 */
export const getTokenExpiry = () => {
  const token = localStorage.getItem('idToken');
  if (!token) return null;
  try {
    const { exp } = jwtDecode(token);
    return exp; // seconds since epoch
  } catch {
    return null;
  }
};

/**
 * Start a timer that will sign the user out 60 s before token expiry.
 */
export const startExpiryWatcher = () => {
  clearTimeout(logoutTimer);

  const exp = getTokenExpiry();
  if (!exp) return;

  const msUntilLogout = exp * 1000 - Date.now() - 60_000; // 1 min early
  if (msUntilLogout <= 0) {
    performLogout();
    return;
  }

  logoutTimer = setTimeout(performLogout, msUntilLogout);
};

/**
 * Clears creds and redirects to /login.
 */
export const performLogout = () => {
  try { signOut(auth); } catch {}
  localStorage.removeItem('idToken');
  localStorage.removeItem('username');
  localStorage.removeItem('authUser');
  window.location.replace('/login');
};
